import React from "react";
import CustomLink from "@/bit/components/components.custom-link";
import Text, { TEXT_COLOR, TEXT_FONT_WEIGHT, TEXT_KIND, TEXT_SIZE, TEXT_WRAP } from "@/bit/components/components.text";

const Header5SecondaryMenu = ({ secondaryMenu }) => {
  return (
    <>
      {secondaryMenu && secondaryMenu.items && (
        <div className="header5-secondary-menu">
          <div className="container">
            <div className="secondary-menu">
              {
                Object.entries(secondaryMenu.items).map(([key, item]) => (
                  <div className={`secondary-menu-item ${secondaryMenu.selectedLink === item.text ? 'active' : ''}`} key={key}>
                    <CustomLink
                      href={item.link}
                      ariaLabel={item.ariaLabel}
                      title={item.title}
                    >
                      <Text
                        text={item.text}
                        fontType={TEXT_FONT_WEIGHT.REGULAR}
                        size={TEXT_SIZE.T7}
                        wrap={TEXT_WRAP.NOWRAP}
                        color={secondaryMenu.selectedLink === item.text ? TEXT_COLOR.WHITE : TEXT_COLOR.GREY4}
                        display="block"
                      />
                    </CustomLink>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      )}
      <style jsx>{`.header5-secondary-menu {
  display: flex;
  align-items: center;
  background-color: #0b2739;
  margin-bottom: 0.5rem;

  .secondary-menu {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    padding: 0.1rem 0 0.1rem 0;
    overflow-x: auto;

    &::-webkit-scrollbar{
      display: none;
    }

    .secondary-menu-item {
      display: flex;
      align-items: center;
      height: 3rem;
      border-bottom: 0.15rem solid transparent; /* Ajusta el grosor y el color del borde según tus necesidades */
      &.active {
        border-color: white;
        box-sizing: border-box;
      }
    }
  }

  @media screen and (min-width: 1280px) {
    margin-bottom: 1rem;
  }
}
`}</style>
    </>
  );
};
export default Header5SecondaryMenu;
